/**
 * Given each chip's `offsetTop` (in DOM order) from a wrapping measurer, return
 * how many chips to show inline: all of them when they fit on one row, else the
 * first-row count minus one slot reserved for the "+N more" pill (FS-537).
 */
export function computeVisibleCount(offsetTops: number[]): number {
  if (offsetTops.length === 0) return 0
  const firstTop = offsetTops[0]
  let firstRow = 0
  for (const top of offsetTops) {
    if (top === firstTop) firstRow++
    else break
  }
  return firstRow >= offsetTops.length ? offsetTops.length : Math.max(1, firstRow - 1)
}
